import * as React from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "ui-components";
import { NavItem } from "./NavItem";
import { Loader } from "../loader/Loader";
import { syncEmployees } from "../../redux/actions/employeeActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import logo from "../../images/vegait-logo-black.svg";

export const Nav: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.employee);
  const canViewAcsEvents = useAppSelector(
    (state) => state.auth.authority === "ADMIN" || state.auth.authority === "SUPER_ADMIN"
  );
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const hamburgerClass = isOpen
    ? "header__hamburger js-header-hamburger header__hamburger--open"
    : "header__hamburger js-header-hamburger";

  const contentClass = isOpen
    ? "header__actions js-header-actions header__actions--open"
    : "header__actions js-header-actions";

  const handleToogle = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = () => {
    navigate("/");
  };

  const handleLoader = () => {
    if (isLoading) {
      return <Loader />;
    }

    return null;
  };

  const handleSync = () => {
    dispatch(syncEmployees())
      .unwrap()
      .then(() => {
        navigate("/employee");
      });
  };

  const onLogout = () => {
    localStorage.removeItem("persist:root");
    navigate("/login");
  };

  return (
    <header className="header">
      {handleLoader()}
      <button onClick={handleNavigate} type="button" className="header__logo">
        <img src={logo} alt="" className="header__logo-img" />
      </button>
      <button onClick={handleToogle} className={hamburgerClass}>
        <span className="header__hamburger__bar"></span>
        <span className="sr-only">Menu</span>
      </button>
      <div className={contentClass}>
        <nav className="header__nav">
          <NavItem to="/" text={"Control panel"} />
          <NavItem to="/admin" text={"Manage admins"} />
          <NavItem to={"/statistics"} text={"Statistics"} />
          {canViewAcsEvents && <NavItem to="/acs-events" text="Token events" />}
        </nav>
      </div>
      <div className="header__buttons">
        <Button onClick={onLogout} text={"Log out"} />
      </div>
    </header>
  );
};
